import type { TicketUnreadDTO } from '@hearth/shared';
import { useQuery } from '@tanstack/react-query';
import type { RouteObject } from 'react-router';
import { api } from '../../lib/api';
import { NoteDetailPage } from './NoteDetailPage';
import { NotesPage } from './NotesPage';

export const routes: RouteObject[] = [
  { path: '/notes', element: <NotesPage /> },
  { path: '/notes/:id', element: <NoteDetailPage /> },
];

/** Sidebar badge: notes with something new — replies and status changes, and for administrators new notes too. */
export function useNavCount(): number | undefined {
  const { data } = useQuery({
    queryKey: ['tickets', 'unread'],
    queryFn: ({ signal }) => api.get<TicketUnreadDTO>('/api/tickets/unread', { signal }),
    staleTime: 60_000,
    refetchInterval: 60_000,
    select: (result) => result.unread,
  });
  return data;
}
